interface IConfiguration {
  tracking: object;
  about: {
    member: string;
    build?: string;
    application: string;
    subheader: string;
    version: {
      external?: string;
      ui: string;
      api: string;
    };
  };
  target?: {
    environment: string;
  };
  notifications?: {
    gcms: {
      key: string;
      projectId: string;
    };
  };
}

class ConfigurationDef {
  private internalConfiguration: Partial<IConfiguration> = {};
  private defaultConfiguration: Partial<IConfiguration> = {
    tracking: {},
    about: {
      member: '',
      application: '',
      subheader: '',
      version: {
        ui: '0.1.0',
        api: '1'
      }
    }
  };

  read(key: string) {
    return !!key ? this.internalConfiguration[key] : this.internalConfiguration;
  }

  write(userConfig: Partial<IConfiguration>) {
    this.internalConfiguration = _.merge({}, this.defaultConfiguration, this.internalConfiguration, userConfig || {});
    return this;
  }

  overwrite(userConfig: Partial<IConfiguration>) {
    this.internalConfiguration = _.merge({}, this.defaultConfiguration, userConfig || {});
    return this;
  }
}

export class ConfigurationProvider implements ng.IServiceProvider {
  private configuration = new ConfigurationDef();

  read(key: string) {
    return this.configuration.read(key);
  }

  write(userConfig: Partial<IConfiguration>) {
    this.configuration.write(userConfig);
    return this.configuration;
  }

  request() {
    return this.configuration;
  }

  public $get() {
    return this.configuration;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/src/core/configuration.ts